import { Box, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiryProduct } from '@flecto/types'
import { AvatarProduct, TextProductTitle } from '@flecto/ui'

import { useStoreDetails } from '../../hooks/useStoreDetails'
import { PopoverProductBundleItemsStore } from '../PopoverProductBundleItemsStore/PopoverProductBundleItemsStore'
import { TextCurrencyStore } from '../TextCurrencyStore/TextCurrencyStore'

export type RowProductProps = {
  product: CoreInquiryProduct
}

export function RowProduct({ product: inquiryProduct }: RowProductProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })

  const store = useStoreDetails()

  if (!inquiryProduct.product) {
    return
  }

  return (
    <Flex justify='space-between' gap='sm'>
      <Flex align='center' gap='md'>
        <AvatarProduct product={inquiryProduct.product} />
        <Box>
          <TextProductTitle
            size='sm'
            product={inquiryProduct.product}
            popoverComponent={PopoverProductBundleItemsStore}
            popoverProps={{ product: inquiryProduct.product }}
            withBadgeInsurance={false}
          />
          <Text c='dimmed' size='sm'>
            {t('card_order_summary.label_units', {
              count: inquiryProduct.quantity,
            })}
          </Text>
        </Box>
      </Flex>
      <TextCurrencyStore
        cents={
          store?.show_prices_with_tax
            ? (inquiryProduct?.estimated_booking_cost_with_vat_cents ?? 0)
            : (inquiryProduct?.estimated_booking_cost_cents ?? 0)
        }
      />
    </Flex>
  )
}
